import React from "react";
import { Stack, Typography, Avatar, Box, IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { alpha, useTheme } from "@mui/material/styles";
import { Images } from "../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { HMS, fullName, truncate } from "../../constants/function";
import OutsideClickHandler from "react-outside-click-handler";
import "./index.scss";
import { useHistory } from "react-router-dom";
import PlayIcon from "../icons/PlayIcon";
import { useTranslation } from "react-i18next";
import AIBadge from "../AIBadge";
import ExplicitBadge from "../ExplicitBadge";

export default function ArtistMusicTabRow({
  lastIndex,
  data,
  play,
  actions,
  toggleMenu,
  reference,
}) {
  const theme = useTheme();
  const [isMenu, setMenu] = React.useState(false);
  const history = useHistory();
  const { t } = useTranslation("common");
  const isCardView = useMediaQuery("(max-width:1130px)");
  const primaryLabel = t("trending.tabs.th1");
  const tipperLabel = t("trending.tabs.th2");
  const streamsLabel = t("trending.tabs.th3");
  const studioLabel = t("trending.tabs.th4");
  const timeLabel = t("trending.tabs.th5");
  const moreLabel = t("trending.tabs.th6");
  return (
    <tr
      className={`artist-music-tab-row${isCardView ? " card-layout" : ""}`}
      style={{ position: "relative" }}
      ref={reference || null}
    >
      <td
        data-label={isCardView ? primaryLabel : undefined}
        onClick={(e) => {
          if (!e.target.closest(".prevent-row-click")) {
            play(e);
          }
        }}
        style={{ cursor: "pointer", paddingLeft: "20px" }}
      >
        <Stack direction="row" spacing={2}>
          <Stack className={"__music_thumb" + " _cp"}>
            <Avatar
              src={
                data?.thumbnailImg?.filePath ??
                data?.GIF?.filePath ??
                Images.dummy
              }
            />

            <PlayIcon
              onClick={(e) => {
                e.stopPropagation();
                play(e);
              }}
              className="__play_hover"
              sx={{
                fontSize: 28,
                position: "relative",
                top: "-20px",
              }}
            />
          </Stack>
          <Stack direction="column" alignItems="start">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="body1"
                className="fs-16 _cp"
                sx={{ textAlign: "left" }}
                title={data["title"]}
                onClick={(e) => {
                  e.stopPropagation();
                  play(e);
                }}
              >
                {truncate(data["title"], 27)}
              </Typography>
              <AIBadge show={data["isAIGenerated"]} size="small" />
              <ExplicitBadge show={data["isExplicit"]} size="small" />
              {data["private"] ? (
                <LockIcon
                  sx={{
                    width: "11px",
                    height: "11px",
                    padding: "2px",
                    color: "#989898",
                    backgroundColor: "#4E4E4E",
                  }}
                  className="__small_icon _lock_hover"
                />
              ) : null}
            </Stack>
            <Stack
              direction="row"
              sx={{
                overflowX: "scroll",
                gap: "6px",
                width: isCardView ? "100%" : "245px",
              }}
              className="scroll_display_musicCard"
            >
              {data.artistData ? (
                data.artistData.length > 1 ? (
                  data.artistData.map((a, index) => (
                    <Typography
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(`/app/ArtistProfile/${a.uId}`);
                      }}
                      key={index}
                      variant="body2"
                      className="fs-14 fade-text _cp prevent-row-click"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {a?.displayArtistName ?? fullName(a)}
                      {index == data.artistData.length - 1 ? "" : ","}
                    </Typography>
                  ))
                ) : (
                  data.artistData.map((a, index) => (
                    <Typography
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(`/app/ArtistProfile/${a.uId}`);
                      }}
                      key={index}
                      variant="body2"
                      className="fs-14 fade-text _cp prevent-row-click"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {data?.artistDetails?.firstName
                        ? ""
                        : a?.displayArtistName ?? fullName(a)}
                    </Typography>
                  ))
                )
              ) : (
                <Typography variant="body2" className="fs-14 fade-text">
                  {fullName(data["createdByDetails"])}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      </td>

      <td data-label={isCardView ? tipperLabel : undefined} style={{ paddingLeft: "16px" }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="start"
        >
          {data?.topTipper?.topTipperProfile?.filePath ? (
            <Avatar src={data?.topTipper?.topTipperProfile?.filePath} />
          ) : null}
          <Typography
            variant="body2"
            className="fs-14"
            sx={{ textAlign: "start" }}
          >
            {data?.topTipper?.topTipperName ?? ""}
          </Typography>
        </Stack>
      </td>

      <td data-label={isCardView ? streamsLabel : undefined} style={{ paddingLeft: "16px" }}>
        <Typography variant="body2" className="fs-14 fade-text">
          {Math.round(data?.listens ?? 0)}
        </Typography>
      </td>

      <td data-label={isCardView ? studioLabel : undefined} style={{ paddingLeft: "16px" }}>
        <Typography variant="body2" className="fs-14 fade-text">
          {data?.topStudio?.playlistName ?? ""}
        </Typography>
      </td>

      <td
        data-label={isCardView ? timeLabel : undefined}
        className="text-white fs-14"
        style={{ paddingLeft: "16px" }}
      >
        {data["duration"]
          ? HMS(data["duration"])
          : data["totalDuration"]
          ? HMS(data["totalDuration"])
          : ""}
      </td>
      <td
        data-label={isCardView ? moreLabel : undefined}
        className="text-right pr18"
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setMenu(!isMenu);
          }}
        >
          <MoreVertIcon
            className="_cp"
            sx={{
              color: theme.palette.primary.main,
              backgroundColor: alpha(
                theme.palette.primary.main,
                theme.palette.mode === "light" ? 0.12 : 0.3
              ),
              borderRadius: "50%",
              padding: "2px",
            }}
          />
        </IconButton>
      </td>

      {isMenu ? (
        <OutsideClickHandler onOutsideClick={() => setMenu(false)}>
          <Box
            className="__music_card_menu"
            sx={{ position: "absolute" }}
            style={{ top: lastIndex ? "-40px" : "40px" }}
          >
            {actions.map(({ action, key }, index) =>
              action ? (
                <Typography
                  className="__music_card_menu_item"
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenu(false);
                    toggleMenu(key, data["_id"] ? data["_id"] : "");
                  }}
                >
                  {action}
                </Typography>
              ) : null
            )}
          </Box>
        </OutsideClickHandler>
      ) : null}
    </tr>
  );
}
